import { Renderer2 } from '@angular/core';
import { Util } from '@libs/utilities/util';
import { Subject } from 'rxjs';
import { throttleTime, tap } from 'rxjs/operators';

import { NgEventListener } from './event-listener.data';


export class NgEventListenerHelper {

	constructor(
		private renderer: Renderer2
	) {}


	//** Attach passive event listener */
	attachPassiveEventListener(nativeElement: any, eventName: string, callback: (event: any) => void, throttleInterval?: number): NgEventListener {

		//0 - create new listener and set events
		const listener: NgEventListener = new NgEventListener();
		listener.eventName 	= eventName;
		listener.events 	= new Subject<Event>();

		//1 - add observer call back
		const observerCallback: (event: Event) => void = (event: Event): void => { listener.events.next(event); };
		nativeElement.addEventListener(eventName, observerCallback, { passive: true, capture: false });
		listener.teardownCallback = () => { nativeElement.removeEventListener(eventName, observerCallback, { passive: true, capture: false }); };

		//2 - set event subscription
		listener.eventsSubscription = listener.events.pipe(Util.Basic.isDefined(throttleInterval)
			? throttleTime(throttleInterval!, undefined, { leading: true, trailing: true })				// eslint-disable-line no-undefined
			: tap(() => { }) /* no-op */).subscribe((event: Event) => { callback(event); });
		return listener;
	}

	//** Detach event */
	detachEventListener(eventListener: NgEventListener): void {

		//0 - unsubscribe events subscription
		if (Util.Basic.isDefined(eventListener.eventsSubscription)) {
			eventListener.eventsSubscription.unsubscribe();
			eventListener.eventsSubscription = null!;
		}

		//1 - set to complete events
		if (Util.Basic.isDefined(eventListener.events)) {
			eventListener.events.complete();
			eventListener.events = null!;
		}

		//2 - remove callback
		if (Util.Basic.isDefined(eventListener.teardownCallback)) {
			eventListener.teardownCallback();
			eventListener.teardownCallback = null!;
		}
	}

	//** Attach event */
	attachEventListener(nativeElement: any, eventName: string, callback: (event: any) => void, throttleInterval?: number): NgEventListener {

		//0 - add listener
		const listener: NgEventListener = new NgEventListener();
		listener.eventName 	= eventName;
		listener.events 	= new Subject<Event>();

		//1 - subscribe listener
		const observerCallback: (event: Event) => void = (event: Event): void => { listener.events.next(event); };
		listener.teardownCallback = this.renderer.listen(nativeElement, eventName, observerCallback);
		listener.eventsSubscription = listener.events.pipe(Util.Basic.isDefined(throttleInterval)
			? throttleTime(throttleInterval!, undefined, { leading: true, trailing: true })			// eslint-disable-line no-undefined
			: tap(() => { }) /* no-op */).subscribe((event: Event) => { callback(event); });
		return listener;
	}
}
